import { createContext, useContext, useState, useEffect } from 'react';
import { checkAuth } from '../api/auth'; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [user, setUser] = useState(null);

    const refreshAuth = async () => {
        try {
            setIsAuthChecking(true);
            const data = await checkAuth();

            if (data && data.success) {
                setIsLoggedIn(true);
                setUser(data.data ?? null);
                return data.data ?? {};
            }
            setIsLoggedIn(false);
            setUser(null);
            return null;
        } catch (err) {
            setIsLoggedIn(false);
            setUser(null);
            return null;
        } finally {
            setIsAuthChecking(false);
        }
    };

    useEffect(() => {
        refreshAuth();
    }, []);

    return (
        <AuthContext.Provider
            value={{
                isLoggedIn,
                setIsLoggedIn,
                isAuthChecking,
                user,
                refreshAuth,
            }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);